import { fetchAdmissionsPoliciesBySchoolId } from "../domains/admissions/admissions.api";
import { fetchCatchmentsV2BySchoolId } from "../domains/catchmentV2/catchmentV2.api";
import { buildGeneratedJourney } from "./buildGeneratedJourney";
import { journeyForSchool } from "./journeyRegistry";

let rankingCache = null;
let rankingPromise = null;

async function fetchRankingList() {
  if (rankingCache) return rankingCache;
  if (!rankingPromise) {
    rankingPromise = fetch("/api/ranking", {
      cache: "no-store",
      headers: { "Cache-Control": "no-cache" },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to fetch ranking");
        const data = await res.json();
        const list = Array.isArray(data) ? data : data?.schools || data?.data || [];
        rankingCache = list;
        return list;
      })
      .catch((err) => {
        rankingPromise = null;
        throw err;
      });
  }
  return rankingPromise;
}

/**
 * Hand-crafted packs win. Otherwise build from admissions + catchments + ranking.
 */
export async function loadSchoolJourney(school) {
  const hand = journeyForSchool(school);
  if (hand) return { journey: hand, source: "hand" };

  const id = Number(school?.id);
  if (!Number.isFinite(id)) return { journey: null, source: null };

  const [admissions, catchments, rankingList] = await Promise.all([
    fetchAdmissionsPoliciesBySchoolId(id).catch(() => ({ policies: [] })),
    fetchCatchmentsV2BySchoolId(id).catch(() => ({ definitions: [] })),
    fetchRankingList().catch(() => []),
  ]);

  const rankingRow = (rankingList || []).find((row) => Number(row.id) === id) || null;
  const journey = buildGeneratedJourney({
    school,
    rankingRow,
    rankingList,
    admissions,
    catchments,
  });
  return { journey, source: "generated" };
}
